import { render, staticRenderFns } from "./promotion_claim.vue?vue&type=template&id=d61f96d0&scoped=true"
import script from "./promotion_claim.vue?vue&type=script&lang=js"
export * from "./promotion_claim.vue?vue&type=script&lang=js"
import style0 from "./promotion_claim.vue?vue&type=style&index=0&id=d61f96d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61f96d0",
  null
  
)

export default component.exports